import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
/**
 * ThumbnailNavigationRightIcon ~
*/

export default function MiradorIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    viewBox: "0 0 60 55"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: "18",
    height: "55"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "18",
    height: "55",
    transform: "translate(42)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "18",
    height: "34",
    transform: "translate(21)"
  }));
}